// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1sIpM","header":"PatientBlock_header__KPhet","label":"PatientBlock_label__2eCev","option":"PatientBlock_option__2_-JJ"};